module.exports = __webpack_public_path__ + "img/magento-modules-customization@2x.ca422f41.jpeg";